import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadMarkbookData = () => {
    return {
        type: actionTypes.LOAD_MARKBOOK_DATA
    }
}

export const setMarkbookData = (markbookData) => {
    return {
        type: actionTypes.SET_MARKBOOK_DATA,
        markbookData: markbookData
    }
}

export const getMarkbookData = () => {
    return (dispatch) => {
        dispatch(loadMarkbookData())
        axios.get(`/api/v1/markbook`)
            .then(response => {
                dispatch(setMarkbookData(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const loadPersonalInfo = () => {
    return {
        type: actionTypes.LOAD_PERSONAL_INFO
    }
}

export const setPersonalInfo = (personalInfo) => {
    return {
        type: actionTypes.SET_PERSONAL_INFO,
        personalInfo: personalInfo
    }
}

export const getPersonalInfo = () => {
    return (dispatch) => {
        dispatch(loadPersonalInfo())
        axios.get(`/api/v1/personal-information`)
            .then(response => {
                dispatch(setPersonalInfo(response.data))
            })
            .catch(error => {
                //dispatch in Markbook.js
            });
    }
}


export const requestForParallelStudy = (markbook, term) => (dispatch) =>
    new Promise(function (resolve, reject) {
        axios.post(`/api/v1/lms/parallel-study?lms-education-term=` + term)
            .then(response => {
                dispatch(setMessage({type: 'success', text: "Заявка успешно отправлена."}))
                dispatch(setMarkbookData(markbook))
            })
            .catch(error => {
                dispatch(setMessage({type: 'error', text: "Не удалось отправить заявку."}))
            });
    });

export const requestForLiquidation = (markbook, term) => (dispatch) =>
new Promise(function (resolve, reject) {
    axios.post(`/api/v1/lms/liquidation-academic-differences?lms-education-term=` + term)
        .then(response => {
            dispatch(setMessage({type: 'success', text: "Заявка успешно отправлена."}))
            dispatch(setMarkbookData(markbook))
        })
        .catch(error => {
            dispatch(setMessage({type: 'error', text: "Не удалось отправить заявку."}))
        });
});